module.exports = __webpack_public_path__ + "static/media/Wellcome.a880714b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Wellcome.png
// module id = 457
// module chunks = 1